import { Component, OnInit, OnDestroy } from "@angular/core"
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Store } from "@ngrx/store"
import { AppState } from "@store/app-state"
import { Enquiry } from "@models/enquiry";
import { Term } from "@models/term";
import { Subscription } from "rxjs/Subscription";
import { EnquiriesStore } from "@store/enquiries";
import { ConstantsStore } from "@store/constants";
import { Course } from "@models/course";
import { ENQUIRY_ACTIVE_INCREMENT_STEP } from "@reducers/enquiries";

@Component({
  selector: 'online-enrolment-step-one',
  templateUrl: './online-enrolment-step-one.pug',
})
export class OnlineEnrolmentStepOneComponent implements OnInit, OnDestroy {

  public enquiry: Enquiry
  public upcomingTerm: Term
  public terms: Term[]
  public courses: Course[]

  public hasFormBeenSubmitted: boolean

  public coursesForGrade: Course[] = []

  public mf: FormGroup

  private enquirySubscription: Subscription
  private constantsSubscription: Subscription
  private mfSubscription: Subscription

  constructor(
    private store: Store<AppState>,
    private fb: FormBuilder,
  ) {}

  ngOnInit() {
    this.enquirySubscription =
      this.store.select("enquiriesReducer").subscribe((s: EnquiriesStore) => {
        this.enquiry = s.activeEnquiry
      })

    this.constantsSubscription =
      this.store.select("constantsReducer").subscribe((s: ConstantsStore) => {
        this.courses      = s.constants.courses
        this.terms        = s.constants.terms
        this.setUpcomingTerm()
      })

    this.setupMainForm()
  }

  setupMainForm() {
    this.mf = this.fb.group({
      quickFullName:      [this.enquiry.quickFullName, [Validators.required]],
      quickEmail:         [this.enquiry.quickEmail, [Validators.required]],
      quickContactType:   [this.enquiry.quickContactType, [Validators.required]],
      quickMobile:        [this.enquiry.quickMobile, [Validators.required]],
      grade:              [this.enquiry.grade, [Validators.required]],
      courseIds:          this.fb.array(this.enquiry.courseIds, Validators.minLength(1)),
    })

    this.refreshAvailableCourses()

    this.mfSubscription =
      this.mf.valueChanges.subscribe((data) => {
        this.updateModel(data)
      })
  }

  setUpcomingTerm() {
    this.upcomingTerm = this.terms.find((t: Term) => t.isOnlineEnrolmentEnabled)
  }

  isTypeSelected(option: string): boolean {
    return this.mf.get('quickContactType').value == option
  }

  isGradeSelected(option: number): boolean {
    return this.mf.get('grade').value == option
  }

  isCourseSelected(course: Course): boolean {
    return this.enquiry.courseIds.includes(course.id)
  }

  clickedTypeOption(option: string) {
    this.mf.patchValue({ quickContactType: option })
  }

  clickedGradeOption(option: number) {
    this.mf.patchValue({ grade: option })
    this.refreshAvailableCourses()
  }

  clickedCourse(targetCourse: Course) {
    const selectedCourseIds = this.mf.get("courseIds").value as number[]

    let targetCourseIds: number[]
    if (selectedCourseIds.includes(targetCourse.id)) {
      targetCourseIds = selectedCourseIds.filter((cId) => cId != targetCourse.id)
    }
    else {
      targetCourseIds = selectedCourseIds.slice(0)
      targetCourseIds.push(targetCourse.id)
    }
    this.mf.patchValue({ courseIds: targetCourseIds })
  }


  refreshAvailableCourses() {
    if (this.mf.get("grade").value) {
      const targetGrade = this.mf.get("grade").value

      this.mf.patchValue({ courseIds: [] })

      this.coursesForGrade =
        this.courses.filter((c) => c.grade == targetGrade)
    }
  }

  updateModel(data: any) {
    this.enquiry.quickFullName = data.quickFullName
    this.enquiry.quickEmail = data.quickEmail
    this.enquiry.quickContactType = data.quickContactType
    this.enquiry.quickMobile = data.quickMobile
    this.enquiry.grade = data.grade
    this.enquiry.courseIds = data.courseIds
  }

  submittedForm({ value, valid }: { value: any, valid: boolean }) {
    this.hasFormBeenSubmitted = true

    if (this.enquiry.courseIds.length == 0) { return }

    if (valid) {
      this.store.dispatch({ type: ENQUIRY_ACTIVE_INCREMENT_STEP })
    }
  }

  ngOnDestroy() {
    this.enquirySubscription.unsubscribe()
    this.constantsSubscription.unsubscribe()
    this.mfSubscription.unsubscribe()
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/online-enrolment-step-one.ts